import { TableColumnTypes } from "../Controls/Table/TableColumnTypes";

export class ExcelData {

    public name: string;
    // columns, use as column headers and 
    public columns: ExcelColumn[];

    public rows: ExcelRow[];

    constructor() {
        this.rows = [];
    }
}
export type ExcelColumn = {
    name: string;
    type: TableColumnTypes;
    field: string;
}

export type ExcelRow = { [name: string]: string }
